<template xmlns="http://www.w3.org/1999/html">
  <div class="main">

    <div v-if="antisc"
      style="width: 100%;background-color:rgb(255, 244, 216);height: 100vh;display: flex;flex-direction: column;">
      <div style="position: absolute;top:5%;text-align: center;">
        <img src="/static/images/huakai/star1.png" width="35%" />
      </div>
      <div style="position: absolute;top:24%;text-align: center;width: 100%;">
        <div style="font-size: 24px;">防伪查询</div>
      </div>
      <div style="position: absolute;top:29%;text-align: center;width: 100%;">
        <div style="font-size: 20px;">Anti-counterfeiting inquiry</div>
      </div>

      <div style="position: absolute;top:45%;width: 100%;display: flex;align-items: center;flex-direction: column;">
        <div style="width: 90%;">
          <div style="font-weight: bold;font-size: 15px;">当前查询数码<br />
            防伪码：{{ this.antiCode }}<br /><br />
          </div>
          <div style="font-size: 14px;"> 数码为首次查询，您购买的Bonnie Clyde 眼镜产品为正品，请放心使用，欢迎您的再次选购，谢谢！<br />
            This is the first inquiry regarding your purchase. The Bonnie Clyde eyewear product you bought is authentic,
            so please feel confident using it. We look forward to your next purchase. Thank you.
          </div>
        </div>
      </div>
      <div style="position: absolute;bottom:3%;text-align: center;width: 100%;">
        <div style="font-size: 14px;font-weight: bold;">
          小 红 书：BONNIE CLYDE<br />
          品牌官网：<a href="https://bonnieclyde.la">https://bonnieclyde.la</a>
        </div>
      </div>
    </div>




    <div v-if="antifc"
      style="width: 100%;background-color:rgb(231, 230, 230);height: 100vh;display: flex;flex-direction: column;">
      <div style="position: absolute;top:5%;text-align: center;">
        <img src="/static/images/huakai/star2.png" width="35%" />
      </div>
      <div style="position: absolute;top:24%;text-align: center;width: 100%;">
        <div style="font-size: 24px;">防伪查询</div>
      </div>
      <div style="position: absolute;top:29%;text-align: center;width: 100%;">
        <div style="font-size: 20px;">Anti-counterfeiting inquiry</div>
      </div>

      <div style="position: absolute;top:45%;width: 100%;display: flex;align-items: center;flex-direction: column;">
        <div style="width: 90%;">
          <div style="font-weight: bold;font-size: 15px;">当前查询数码<br />
            防伪码：{{ this.antiCode }}<br /><br />
          </div>
          <div style="font-size: 14px;"> 您已重复查询2次本Bonnie Clyde 眼镜产品，若首次查询非本人，谨防假冒。<br />
            You have inquired twice about this Bonnie Clyde eyewear product. If the first inquiry was not made by you,
            please be cautious of counterfeit items.
          </div>
        </div>
      </div>
      <div style="position: absolute;bottom:3%;text-align: center;width: 100%;">
        <div style="font-size: 14px;font-weight: bold;">
          小 红 书：BONNIE CLYDE<br />
          品牌官网：<a href="https://bonnieclyde.la">https://bonnieclyde.la</a>
        </div>
      </div>
    </div>


    <div v-if="antibcz"
      style="width: 100%;background-color:rgb(231, 230, 230);height: 100vh;display: flex;flex-direction: column;">
      <div style="position: absolute;top:5%;text-align: center;">
        <img src="/static/images/huakai/star2.png" width="35%" />
      </div>
      <div style="position: absolute;top:24%;text-align: center;width: 100%;">
        <div style="font-size: 24px;">防伪查询</div>
      </div>
      <div style="position: absolute;top:29%;text-align: center;width: 100%;">
        <div style="font-size: 20px;">Anti-counterfeiting inquiry</div>
      </div>

      <div style="position: absolute;top:45%;width: 100%;display: flex;align-items: center;flex-direction: column;">
        <div style="width: 90%;">
          <div style="font-weight: bold;font-size: 15px;">当前查询数码<br />
            防伪码：{{ this.antiCode }}<br /><br />
          </div>
          <div style="font-size: 14px;">您所查询的防伪码不存在，谨防假冒，或核对后重新输入。<br/>
 The code you entered does not exist. Please be cautious of counterfeit items, or check and re-enter the code.


          </div>
        </div>
      </div>
      <div style="position: absolute;bottom:3%;text-align: center;width: 100%;">
        <div style="font-size: 14px;font-weight: bold;">
          小 红 书：BONNIE CLYDE<br />
          品牌官网：<a href="https://bonnieclyde.la">https://bonnieclyde.la</a>
        </div>
      </div>
    </div>

    <div v-show="isShow">
      <div id="fixedBg"></div>
      <p class="loading_p" id="loadP">
        <img src="/static/images/loadding.gif" />
      </p>
    </div>
  </div>
</template>

<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>


<style scoped>
.text-center {
  width: 100%;
  height: 300px;
  padding: 0px 30px 0px 30px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>

<script>
import { getAntiResult, getInfoByCode } from '../../api/api'

export default {
  data() {
    return {
      isShow: false,
      antiCode: "",
      antifc: false,
      antisc: false,
      antibcz: false
    }
  },
  methods: {
    getResult() {
      this.isShow = true
      const params = this.$route.query;
      const code = params.c;
      this.antiCode = code.substring(0, 16).replace(/(\w{4})(?=\w)/g, '$1 ');
      getAntiResult(code).then(res => {
        const data = res.data;
        this.isShow = false
        if (data == null || data.code == "500") {
          alert("防伪查询失败,请联系管理员");
        } else {
          if (data.code === "300102") {
            this.antisc = false;
            this.antifc = true;
            this.antibcz = false;
          } else if (data.code == "300101") {
            this.antisc = true;
            this.antifc = false;
            this.antibcz = false;
          } else if (data.code == "300106") {
            this.antisc = false;
            this.antifc = false;
            this.antibcz = true;
          }
        }
      }).catch(err =>
        alert("查询异常，请联系管理员")
      )

    }
  },
  created: function () {
    this.getResult()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HuaKai/Index.vue